import { createDefaultCorbanScreeningFilters } from './state';

export default {
  UPDATE_FILTERS(state, data) {
    state.filters = { ...state.filters, ...data };
  },
  RESET_FILTERS(state) {
    state.filters = createDefaultCorbanScreeningFilters();
  },
  SET_PAGE(state, page) {
    state.page = page;
  },
};
